import React from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import loadAsyncScript from './ScriptLoader';

// doc => http://v.qq.com/open/doc/tvpapi2.0.pdf (chinese only)
const tvpAPI = 'https://imgcache.qq.com/tencentvideo_v1/tvp/js/tvp.player_v2.js';

class TencentPlayerMod extends React.Component {
    static propTypes = {
        videoId: PropTypes.string
    };
    render() {
        const elementId = `tencent-video-${this.props.videoId}`;
        return <div id={elementId} className="tencent-video-embed" />;
    }
}

/* eslint react/no-multi-comp: 0 */
export default class TencentVideoEmbed extends React.Component {
    static propTypes = {
        videoId: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.apiLoadedCallBack = this._apiLoadedCallBack.bind(this);
    }
    componentWillUnmount() {
        root.tvp.playerInited = false; // remove init flag before unmounting
    }

    _apiLoadedCallBack() {
        const {tvp} = root;
        tvp.report = () => {
            return true;
        }; // TON-39499 override tvp.report method to suppress error casued in IE 11
        if (!root.tvp.playerInited) {
            root.tvp.playerInited = true;
            const mountId = `tencent-video-${this.props.videoId}`;
            const videoEleId = `tvp-${this.props.videoId}`;
            const video = new tvp.VideoInfo();
            video.setVid(this.props.videoId);
            this.player = new tvp.Player();
            this.player.create({
                playerid: videoEleId, // id for actual <Video /> element
                video,
                modId: mountId, // id for videoWrapper
                autoplay: true,
                html5loop: true,
                playerType: 'html5', // force to use Html5
                isContinuePlay: false, // don't remember play history
                onplaying: () => {
                    // a hack to mute video
                    const myVideo = root.document.getElementById(videoEleId);
                    myVideo.muted = true;
                }
            });
        }
    }

    render() {
        const ScriptLoaderWrapper = loadAsyncScript(TencentPlayerMod, tvpAPI);
        return (
            <ScriptLoaderWrapper
                videoId={this.props.videoId}
                asyncScriptOnLoad={this.apiLoadedCallBack}
            />
        );
    }
}
